import React from 'react';
import '../../styles/SolucionesPublicitarias.css';

const FormatVideo = () => {
  return (
    <section className="format-video-section py-5">
      <div className="container">
        <div className="row align-items-center my-5 justify-content-between">
          {/* TÍTULO A LA IZQUIERDA */}
          <div className="col-md-12 col-lg-5">
          <div className="title-container" data-aos="fade-up">
                    <h2 className="title">Video <span>Formatos</span></h2>
                    <div className="title-underline"></div>
                </div>
          </div>
          <div className="col-md-12 col-lg-7">
              <img src="assets/video-formatos.png" className='img-fluid' alt="video formatos" data-aos="zoom-in" data-aos-delay="0"/>
          </div>

          {/* IMÁGENES SUPERPUESTAS EN EL CENTRO */}
          <div className="col-md-12 col-lg-9 position-relative d-flex justify-content-center dispositivos-mockup mt-4 mt-lg-0 d-none">
            <img
              src="https://dummyimage.com/600x500/red/fff"
              alt="Desktop"
              className="img-fluid dispositivo desktop"
              data-aos="zoom-in"
              data-aos-delay="0"
            />
            <img
              src="https://dummyimage.com/400x300/green/fff"
              alt="Laptop"
              className="img-fluid dispositivo laptop"
              data-aos="zoom-in"
              data-aos-delay="300"
            />
            <img
              src="https://dummyimage.com/300x200/26c757/fff"
              alt="Tablet"
              className="img-fluid dispositivo tablet"
              data-aos="zoom-in"
              data-aos-delay="600"
            />
            <img
              src="https://dummyimage.com/100x200/000/fff"
              alt="Mobile"
              className="img-fluid dispositivo mobile"
              data-aos="zoom-in"
              data-aos-delay="900"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default FormatVideo;

